const { REACT_APP_STATIC_BASE_PATH } = process.env;

export const PLATFORM_BOT_AVATAR = `${REACT_APP_STATIC_BASE_PATH}/images/_global/avatar/avatar-platform-bot.svg`;
